import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Trophy, Swords, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { T } from "@/lib/testIds";

export default function Leagues() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["leagues-mine"],
    queryFn: async () => (await api.get("/leagues/mine")).data,
    staleTime: 60_000,
  });

  if (isLoading) return <div className="totem-card h-40 animate-pulse mt-4" />;
  if (error) return <div className="totem-card p-6 text-totem-red">{String(error.message)}</div>;

  const classic = data?.classic || [];
  const h2h = data?.h2h || [];

  return (
    <div data-testid={T.leaguesPage} className="space-y-4 pt-1 animate-fade-up">
      <section>
        <div className="label-caps mb-2 flex items-center gap-2">
          <Trophy size={12} /> Classic leagues
        </div>
        {classic.length === 0 && (
          <div className="totem-card p-6 text-sm text-totem-textDim text-center">
            You aren&apos;t in any classic leagues yet.
          </div>
        )}
        <ul className="space-y-2">
          {classic.map((l) => (
            <li key={l.id} data-testid={T.leagueRow}>
              <Link
                to={`/leagues/${l.id}`}
                className="totem-card p-4 flex items-center justify-between hover:border-totem-green/40 transition"
              >
                <div className="min-w-0">
                  <div className="font-semibold truncate">{l.name}</div>
                  <div className="mono text-[10px] uppercase text-totem-textDim">
                    {l.league_type === "s" ? "Public" : "Private"} • rank {l.entry_rank || "—"} / {l.entry_last_rank || "—"}
                  </div>
                </div>
                <ChevronRight className="text-totem-textDim" size={18} />
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {h2h.length > 0 && (
        <section>
          <div className="label-caps mb-2 flex items-center gap-2">
            <Swords size={12} /> Head-to-head leagues
          </div>
          <ul className="space-y-2">
            {h2h.map((l) => (
              <li key={l.id} className="totem-card p-4 flex items-center justify-between">
                <div className="min-w-0">
                  <div className="font-semibold truncate">{l.name}</div>
                  <div className="mono text-[10px] uppercase text-totem-textDim">Head-to-head</div>
                </div>
                <span className="mono text-[10px] uppercase text-totem-textFaint">Coming soon</span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
